// =========================================================
// SECTION SERVICES — Splide VERTICAL en boucle auto (pattern wp-power-limit,
// section « Nos engagements ») : 4 services visibles qui défilent vers le haut,
// flèches haut/bas custom. Horizontal 1 par vue en mobile.
// =========================================================
import Splide from '@splidejs/splide';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.km-services').forEach((section) => {

        const el = section.querySelector('.km-services__splide');
        if (!el || el.dataset.kmServicesInitialized) return;
        el.dataset.kmServicesInitialized = '1';

        const splide = new Splide(el, {
            type: 'loop', // boucle infinie : l'autoplay tourne sans butée
            direction: 'ttb',
            height: '23rem', // calé sur des items uniformes 1 ligne de desc
            // (le rythme vient du line-clamp:1 des descriptions, cf. SCSS)
            perPage: 4,
            perMove: 1,
            gap: '1.25rem', // espace entre services (retour Olivier, ex-.75rem)
            // bullets de position PARTOUT (retour Olivier : validées en mobile,
            // étendues au desktop en VERTICAL à la place des flèches)
            pagination: true,
            arrows: false,
            focus: 0, // 1 bullet PAR service (sinon Splide pagine par groupe de perPage)
            autoplay: true,
            interval: 3500,
            pauseOnHover: true,
            pauseOnFocus: false,
            speed: 900,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            reducedMotion: {speed: 900, rewindSpeed: 900}, // glisse conservée (politique Olivier)
            breakpoints: {
                // Mobile : bascule en slider HORIZONTAL 1 par vue (config validée
                // en prod sur wp-power-limit, section engagements).
                991: {
                    direction: 'ltr',
                    height: 'auto',
                    perPage: 1,
                    gap: '1rem',
                },
            },
        });

        splide.mount();
        el.splide = splide;

        const prev = section.querySelector('.km-services__arrow--prev');
        const next = section.querySelector('.km-services__arrow--next');
        if (prev) prev.addEventListener('click', () => splide.go('<'));
        if (next) next.addEventListener('click', () => splide.go('>'));

        // ----- Compteurs animés des chiffres clés — REJOUENT à chaque entrée dans
        // le viewport (demande Olivier). Cible mémorisée au premier parse, format
        // brut sans séparateur (fidèle maquette : « 2500 »).
        const stats = section.querySelectorAll('.km-services__stat-number');
        if (stats.length && 'IntersectionObserver' in window) {
            // Anti-« saut » : le suffixe (K, +) est rendu CÔTÉ SERVEUR dans son propre
            // span (.km-services__stat-suffix, champ ACF dédié) — le compteur ne touche
            // que les digits. Largeur FIXE = largeur du nombre final (mesurée après
            // chargement des fonts, convertie en em pour suivre le responsive),
            // chiffres calés à droite contre le suffixe → rien ne bouge autour.
            document.fonts.ready.then(() => {
                stats.forEach((elNum) => {
                    const target = elNum.textContent.trim().replace(/[^\d]/g, '');
                    if (!target) return;
                    elNum.dataset.kmTarget = target;
                    elNum.style.display = 'inline-block';
                    elNum.style.textAlign = 'right';
                    const em = elNum.offsetWidth / parseFloat(getComputedStyle(elNum).fontSize);
                    elNum.style.minWidth = em.toFixed(3) + 'em';
                    io.observe(elNum);
                });
            });
            const animate = (elNum) => {
                const target = parseInt(elNum.dataset.kmTarget || '', 10);
                if (!target || elNum.dataset.kmCounting) return;
                elNum.dataset.kmCounting = '1';
                const t0 = performance.now();
                const duration = 1800;
                const tick = (now) => {
                    const p = Math.min(1, (now - t0) / duration);
                    const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
                    elNum.textContent = String(Math.round(target * eased));
                    if (p < 1) {
                        requestAnimationFrame(tick);
                    } else {
                        delete elNum.dataset.kmCounting;
                    }
                };
                requestAnimationFrame(tick);
            };
            const io = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) animate(entry.target);
                });
            }, {threshold: .6});
            // (l'observe se fait dans le fonts.ready plus haut, une fois la
            // structure numérique en place — pas d'observe direct ici)
        }

        // ----- Parallax de la photo de fond au scroll (retour Olivier 09/07) :
        // HORIZONTAL (gauche → droite, le vertical était trop discret), débord
        // latéral ±8% (cf. SCSS __bg img) scrubbé sur la traversée.
        const bgImg = section.querySelector('.km-services__bg img');
        if (bgImg && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            gsap.set(bgImg, {xPercent: -8});
            gsap.to(bgImg, {
                xPercent: 8,
                ease: 'none',
                scrollTrigger: {
                    trigger: section,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                },
            });
        }
    });

});
